import { at, drawLine, growFrom } from '../RailsArchitecture/timelineHelpers';
import {
  ActivateCard,
  ACTIVATIONS,
  AgentsRulesCard,
  Connector,
  DecisionCard,
  EDGE,
  MOBILE_ACTIVATE_RECT,
  MOBILE_CARD_W,
  MOBILE_DECISION_RECT,
  MOBILE_INPUT_RECT,
} from './atoms';
import { useComboTimeline, type BuildComboTimeline } from './useComboTimeline';

const ID = {
  input: 'combo-m-input',
  connectA: 'combo-m-connect-a',
  decision: 'combo-m-decision',
  connectB: 'combo-m-connect-b',
  activate: 'combo-m-activate',
};

const buildMobileTimeline: BuildComboTimeline = ({ tl, lightActivation }) => {
  tl.addLabel('input', 0.5);
  growFrom(tl, ID.input, 'input', {
    entry: EDGE.top,
    to: 50,
    duration: 0.7,
  });

  tl.addLabel('connectA', at('input', 0.7));
  drawLine(tl, ID.connectA, 'connectA', 0.25);

  tl.addLabel('decision', at('connectA', 0.25));
  growFrom(tl, ID.decision, 'decision', {
    entry: EDGE.top,
    to: 50,
    duration: 0.5,
  });

  tl.addLabel('connectB', at('decision', 0.5));
  drawLine(tl, ID.connectB, 'connectB', 0.25);

  tl.addLabel('activate', at('connectB', 0.25));
  growFrom(tl, ID.activate, 'activate', {
    entry: EDGE.top,
    to: 50,
    duration: 0.5,
  });
  ACTIVATIONS.forEach((_, index) => {
    tl.call(lightActivation, [index], at('activate', 0.5 + index * 0.12));
  });
};

/** Equal-width stacked cards; Decision stays compact (smaller logo, less gap). */
export function MobileAnimation() {
  const { container, litCount } = useComboTimeline(buildMobileTimeline);

  return (
    <div
      ref={container}
      className="mx-auto flex w-full flex-col items-center"
      style={{ maxWidth: MOBILE_CARD_W }}
    >
      <AgentsRulesCard borderId={ID.input} rect={MOBILE_INPUT_RECT} />

      <Connector id={ID.connectA} orientation="vertical" className="h-[40px]" />

      <DecisionCard borderId={ID.decision} rect={MOBILE_DECISION_RECT} />

      <Connector id={ID.connectB} orientation="vertical" className="h-[40px]" />

      <ActivateCard
        borderId={ID.activate}
        litCount={litCount}
        rect={MOBILE_ACTIVATE_RECT}
      />
    </div>
  );
}
